/* eslint-disable no-console */
import { Component, ReactNode, ErrorInfo } from "react";

// Define the props interface for the ErrorBoundary
interface Props {
  children: ReactNode; // ReactNode type allows any valid React child
}

// Define the state interface for the ErrorBoundary
interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

// Create the ErrorBoundary component
class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // Initialize state
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  // Update state when an error is caught
  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null };
  }

  // Log the error and error info
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.log("Error:", error);
    console.log("Error Info:", errorInfo);
    // Update state with error info
    this.setState({ errorInfo });
  }

  render() {
    // If there's an error, display the fallback UI
    if (this.state.hasError) {
      return (
        <div>
          <h1>Something went wrong.</h1>
          <details style={{ whiteSpace: "pre-wrap" }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo?.componentStack}
          </details>
        </div>
      );
    }

    // Otherwise, render the children components
    return this.props.children;
  }
}

export default ErrorBoundary;
